import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import LoginPage from './pages/LoginPage';
import LeadsPage from './pages/LeadsPage';
import CampaignsPage from './pages/CampaignsPage';
import CampaignDetailPage from './pages/CampaignDetailPage';
import CampaignFilesPage from './pages/CampaignFilesPage';
import ImportedLeadsPage from './pages/ImportedLeadsPage';
import CallsPage from './pages/CallsPage';
import DealsPage from './pages/DealsPage';
import CompaniesPage from './pages/CompaniesPage';
import InvoicesPage from './pages/InvoicesPage';
import PartnersPage from './pages/PartnersPage';
import TasksPage from './pages/TasksPage';
import StockItemsPage from './pages/StockItemsPage';
import CompanyPartnershipsPage from './pages/CompanyPartnershipsPage';
import ProfilesPage from './pages/ProfilesPage';
import ProjectsPage from './pages/ProjectsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ReportsPage from './pages/ReportsPage';
import CalendarPage from './pages/CalendarPage';
import PipelinePage from './pages/PipelinePage';
import IntegrationsPage from './pages/IntegrationsPage';
import Settings from './pages/Settings';
import AppSettingsPage from './pages/AppSettings';
import GlobalSettingsPage from './pages/GlobalSettings';
import UsersPage from './pages/UsersPage';
import RolesPage from './pages/RolesPage';
import LogsPage from './pages/LogsPage';
import PermissionsPage from './pages/PermissionsPage';
import ListDetailPage from './pages/ListDetailPage';
import AgentCampaignsPage from './pages/AgentCampaignsPage';

// Layout component with key for forcing re-render
const AppLayout = ({ children, userEmail }) => {
  const location = window.location.pathname;
  const isLoginPage = location === '/login';
  
  // Utiliser l'email comme clé pour forcer le re-render du sidebar
  const sidebarKey = userEmail || 'no-user';
  
  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {!isLoginPage && userEmail && <Sidebar key={sidebarKey} />}
      <main style={{ 
        flex: 1, 
        marginLeft: (!isLoginPage && userEmail) ? '288px' : '0',
        backgroundColor: '#f3f4f6',
        transition: 'margin-left 0.3s ease'
      }}>
        {children}
      </main>
    </div>
  );
};

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userEmail, setUserEmail] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setUserEmail(session?.user?.email || null);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      console.log('App - Auth state changed:', session?.user?.email);
      setSession(session);
      setUserEmail(session?.user?.email || null);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      Chargement...
    </div>;
  }

  return (
    <Router>
      <AppLayout userEmail={userEmail}>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Private routes */}
          {session ? (
            <>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/leads" element={<LeadsPage />} />
              <Route path="/campaigns" element={<CampaignsPage />} />
              <Route path="/campaigns/:id" element={<CampaignDetailPage />} />
              <Route path="/campaigns/:id/files" element={<CampaignFilesPage />} />
              <Route path="/campaigns/:campaignId/files/:fileId/leads" element={<ImportedLeadsPage />} />
              <Route path="/calls" element={<CallsPage />} />
              <Route path="/agent-campaigns" element={<AgentCampaignsPage />} />
              <Route path="/deals" element={<DealsPage />} />
              <Route path="/partners" element={<PartnersPage />} />
              <Route path="/invoices" element={<InvoicesPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/tasks" element={<TasksPage />} />
              <Route path="/stock_items" element={<StockItemsPage />} />
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/company_partnerships" element={<CompanyPartnershipsPage />} />
              <Route path="/profiles" element={<ProfilesPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/pipeline" element={<PipelinePage />} />
              <Route path="/integrations" element={<IntegrationsPage />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/roles" element={<RolesPage />} />
              <Route path="/permissions" element={<PermissionsPage />} />
              <Route path="/logs" element={<LogsPage />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/app-settings" element={<AppSettingsPage />} />
              <Route path="/global-settings" element={<GlobalSettingsPage />} />
              <Route path="/list/:id" element={<ListDetailPage />} />
            </>
          ) : (
            <Route path="*" element={<Navigate to="/login" replace />} />
          )}
        </Routes>
      </AppLayout>
    </Router>
  );
}

export default App;




